import BellRingingIcon from 'assets/svg/bell-ringing-white.svg';
import { SaveSearchButtonMobileRoot } from 'components/saved-search/save-button/styled';
import { Button } from 'ds/components/button';
import { useLocale } from 'locale';
import React from 'react';


interface SaveSearchMobileButtonProps {
  disabled: boolean;
  onClick: () => void;
}

const SaveSearchMobileButton: React.FC<SaveSearchMobileButtonProps> = ({ onClick, disabled }) => {
  const { t } = useLocale();

  if (disabled) return null;

  return (
    <SaveSearchButtonMobileRoot>
      <Button
        data-auto="save-search-button"
        onClick={onClick}
        size="extraLarge"
        isInitialIconColor
      >
        <BellRingingIcon width={24} height={24} />
        {t('savedSearch.saveButton.withImpact.label')}
      </Button>
    </SaveSearchButtonMobileRoot>
  );
};

export default SaveSearchMobileButton;
